import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined'
import { Button, Grid, Typography, Link, Box } from '@mui/material'
import { styled } from '@mui/system'
import * as Sentry from '@sentry/react'
import { login } from 'api/user'
import OcrReaderLogo from 'assets/images/logoSl.svg'
import ServiceEndNotice from 'components/ServiceEndNotice'
import { useNavigate } from 'react-router-dom'

import LoginLayout from './LoginLayout'

const GridContainer = styled(Grid)({
  height: '100%',
})

const LbSidebar = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: 'rgb(5, 214, 134)',
  color: '#ffffff',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const LbContent = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: '#fff',
  color: '#888888',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const Logo = styled(Box)({
  width: '100%',
  maxWidth: '330px',
  height: '50px',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  backgroundImage: `url("${OcrReaderLogo}")`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
})

const LbInstruction = styled('div')(() => ({
  width: '100%',
  minHeight: '140px',
  overflow: 'hidden',
  fontSize: '16px',
  lineHeight: '1.7em',
  letterSpacing: '0.02em',
  textAlign: 'center',
}))

const LbFirst = styled('div')(() => ({
  fontSize: '13px',
  color: '#aaaaaa',
  maxWidth: '280px',
  textAlign: 'start',
}))

const LbFirstTitle = styled(Typography)(() => ({
  marginBottom: '5px',
}))

const LbFirstContent = styled(Typography)(() => ({
  lineHeight: '1.3em',
}))

const BtnSecondary = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 550,
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: 'rgb(5, 214, 134)',
  borderColor: 'rgb(5, 214, 134)',
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: 'rgb(5, 214, 134)',
    borderColor: 'rgb(5, 214, 134)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0062cc',
    borderColor: '#005cbf',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
})

const Login: React.FC = () => {
  const navigate = useNavigate()
  const handleLoginClick = async () => {
    try {
      const { loginUrl } = await login()
      window.location.href = loginUrl
    } catch (err) {
      Sentry.captureException(err)
      navigate('failure')
    }
  }

  return (
    <LoginLayout>
      <GridContainer container sx={{ height: '100%' }}>
        <LbSidebar item sm={5}>
          <Logo />
        </LbSidebar>
        <LbContent item sm={7}>
          <ServiceEndNotice />
          <LbInstruction>
            <Typography variant="body1" sx={{ marginBottom: (theme) => theme.spacing(2) }}>
              ビジネスIDで、
              <br />
              OCR Readerにログインしてください
            </Typography>
            <BtnSecondary variant="contained" disableRipple onClick={() => void handleLoginClick()}>
              ログイン
            </BtnSecondary>
          </LbInstruction>
          <LbFirst>
            <LbFirstTitle variant="body2">
              <CheckBoxOutlinedIcon
                style={{
                  color: 'rgb(3, 135, 85)',
                  height: '14px',
                  margin: '0px -3px -2px',
                }}
              />
              初めてご利用の場合
            </LbFirstTitle>
            <LbFirstContent variant="body2">
              ご利用には事前申請されたビジネスIDが必要となります。IDの作成手順は
              <Link
                href="https://www.lycbiz.com/jp/manual/line-ads/account_001/"
                sx={{ color: '#007bff' }}
              >
                こちら
              </Link>
            </LbFirstContent>
          </LbFirst>
        </LbContent>
      </GridContainer>
    </LoginLayout>
  )
}

export default Login
